import { FC } from 'react';
import styled from 'styled-components';

import { MpParagraph } from 'shared/ui/MpParagraph';
import { MpText } from 'shared/ui/MpText';
import { MpUl } from 'shared/ui/MpUl';

export const SubheadingStyled = styled.b`
	font-weight: 600;
`;

export const DenvikDescription: FC = () => (
	<div>
		<MpParagraph>
			Обработка загружает данные о&nbsp;поступлениях, списании материалов, отчетах о&nbsp;розничных продажах,
			выпуске продукции и&nbsp;перемещениях и&nbsp;формирует документы в&nbsp;1С. По&nbsp;сравнению
			со&nbsp;старыми версиями обмен работает на&nbsp;порядок стабильнее и&nbsp;добавилось множество новых
			возможностей.
		</MpParagraph>
		<MpUl>
			<li>
				<MpText>
					<SubheadingStyled>Можно работать через браузер</SubheadingStyled>
					<br />
					Обработка поддерживает веб-клиент, в том числе 1С:ГРМ
				</MpText>
			</li>
			<li>
				<MpText>
					<SubheadingStyled>Легкий старт, сразу начинайте работу</SubheadingStyled>
					<br />
					При&nbsp;первом открытии по&nbsp;умолчанию заполнена большая часть настроек: создание номенклатуры,
					настройка видов выпуска продукции и&nbsp;списания материалов.
				</MpText>
			</li>
			<li>
				<MpText>
					<SubheadingStyled>Миграция старой базы по&nbsp;кнопке</SubheadingStyled>
					<br />
					Большинство действий по&nbsp;миграции происходят автоматически. Все&nbsp;моменты, требующие
					внимания, подсвечиваются в&nbsp;интерфейсе.
				</MpText>
			</li>
			<li>
				<MpText>
					<SubheadingStyled>Обновление, которое не&nbsp;останавливает работу</SubheadingStyled>
					<br />
					Не&nbsp;нужно покидать базу во&nbsp;время установки, а&nbsp;также уменьшается риск поломки
					при&nbsp;обновлениях. Это&nbsp;возможно благодаря тому, что&nbsp;модуль поставляется
					не&nbsp;расширением, а&nbsp;в&nbsp;виде внешней обработки.
				</MpText>
			</li>
			<li>
				<MpText>
					<SubheadingStyled>Уведомления об&nbsp;обмене данными с&nbsp;Dodo IS </SubheadingStyled>
					<br />
					На&nbsp;электронную почту будет приходить письмо с&nbsp;количеством загруженных документов,
					созданных номенклатур или&nbsp;причинах несостоявшегося автоматического обмена.
				</MpText>
			</li>
			<li>
				<MpText>
					<SubheadingStyled>Гибкая настройка документов</SubheadingStyled>
					<br />
					Предусмотрены настройки по&nbsp;оформляемым документам: заполнение реквизитов, соотнесение
					реквизитов и&nbsp;счётов. Также&nbsp;упрощен процесс проведения продаж с&nbsp;нулевой ценой.
				</MpText>
			</li>
			<li>
				<MpText>
					<SubheadingStyled>Предупреждение о&nbsp;дублировании элементов</SubheadingStyled>
					<br />
					Обработка предупреждает о&nbsp;дублировании элементов справочника номенклатуры при&nbsp;переходе
					со&nbsp;старой версии обмена на&nbsp;новую.
				</MpText>
			</li>
			<li>
				<MpText>
					<SubheadingStyled>Работа в облачной 1С&nbsp;Фреш</SubheadingStyled>
					<br />
					Обработка «Обмен DODO IS» опубликована в магазине расширений 1С Фреш и доступна к установке
				</MpText>
			</li>
		</MpUl>
		<MpText>Обработка адаптирована для пользователей 1С:Бухгалтерии версии КОРП и ПРОФ.</MpText>
	</div>
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DenvikDescription_eng: FC = () => (
	<div>
		<MpParagraph>
			Processing extracts data from Dodo IS and generates documents in 1C. Thanks to easy installation and setup,
			you can quickly connect accounting without the help of an external specialist. It allows loading data on
			receipts, material write-offs, reports on retail sales, production output, and movements. Regular updates
			are released for processing.
			<br />
			<br />
			Adapted for users of the Accounting version KORP and PROF.
		</MpParagraph>
		<MpText style={{ marginTop: `16px`, marginBottom: `12px` }}>Key benefits:</MpText>
		<MpUl>
			<li>
				<MpText>
					<SubheadingStyled>All settings are already filled in, you can start working</SubheadingStyled>
					<br />
					Upon first opening, most settings are pre-filled: creating nomenclature, configuring types of
					product output, and material write-offs.
				</MpText>
			</li>
			<li>
				<MpText>
					<SubheadingStyled>
						The processing is delivered not as an extension, but as an external processing
					</SubheadingStyled>
					<br />
					This allows you to stay in the database during installation and reduces the risk of breakage during
					updates.
				</MpText>
			</li>
			<li>
				<MpText>
					<SubheadingStyled>Individual settings for documents</SubheadingStyled>
					<br />
					Settings are provided for documents to be formatted: filling in details, correlating details and
					accounts. The sales process with zero price is also simplified.
				</MpText>
			</li>
			<li>
				<MpText>
					<SubheadingStyled>Notification of the result of automatic exchange</SubheadingStyled>
					<br />
					Notification of the result of automatic exchange. An email will be sent with information about the
					number of loaded documents, created nomenclatures, or the reasons for the unsuccessful automatic
					exchange.
				</MpText>
			</li>
			<li>
				<MpText>
					<SubheadingStyled>Warning about duplication of elements</SubheadingStyled>
					<br />
					The processing warns about duplicating elements of the nomenclature directory when transitioning
					from the old exchange version to the new one.
				</MpText>
			</li>
			<li>
				<MpText>
					<SubheadingStyled>Working in cloud 1C&nbsp;Fresh</SubheadingStyled>
					<br />
					The “DODO IS Exchange” processing has been published in the 1C&nbsp;Fresh extension store and is
					available for installation
				</MpText>
			</li>
		</MpUl>
	</div>
);
